import React, { useEffect } from 'react';
import { actions } from 'redux/local';
import Shared from 'screens/shared';
import { _t } from 'utils';
import { ROUTE } from 'constant';
import Groups from './groups';
import Users from './users';

export default ({ history = {} }) => {
  const { pathname = '' } = window.location;
  const type = pathname.endsWith('/groups') ? 'groups' : 'users';

  useEffect(() => {
    actions.common.setLayoutTitle({
      layout: {
        title: _t('User Management'),
        menu: ROUTE.DASHBOARD.USER_MANAGEMENT.key,
      },
    });
  }, []);

  // const gotoUsers = () => history.push(ROUTE.DASHBOARD.USER_MANAGEMENT_USERS.path);

  // const gotoGroups = () => history.push(ROUTE.DASHBOARD.USER_MANAGEMENT_GROUPS.path);

  return (
    <div className="screen-user-managements screen-common">
      {/* <div className="screen-user-managements-menu">
        <div className="screen-user-managements-menu-item" onClick={gotoUsers}>
          <Shared.widgets.Icon name="user-friends" />
          <span>Users</span>
        </div>
        <div className="screen-user-managements-menu-item" onClick={gotoGroups}>
          <Shared.widgets.Icon name="users" />
          <span>Groups</span>
        </div>
      </div> */}
      <Shared.widgets.Tabs
        selectedTab={type === 'groups' ? 1 : 0}
        tabs={[
          {
            tabName: 'Users',
            render: <Users history={history} />,
          },
          {
            tabName: 'Groups',
            render: <Groups history={history} />,
          },
        ]}
        onChange={(id) => history.replace(`/user-management/${id === 1 ? 'groups' : 'users'}`)}
      />
    </div>
  );
};
